import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { CacheDuration } from '../constants/app.constant';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService extends BaseService {
  preferences$: Subject<any> = new Subject<any>();
  constructor(protected http: HttpClient, private cache: CacheResolverService) {
    super(http);
  }
  loadPreferences() {
    // const url = super.serviceUrl(
    //   this.apiConfig.config,
    //   ConfigApi.GetStaticData
    // );

    return super.fetch(this.apiConfig.config+'/api/preference', { params: { fields: "canDisplay" } }).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          this.setPreferences(response.data);
          this.preferences$.next();
        }
        return response;
      })
    );
  }

  savePreferences(request) {
    return super.put(this.apiConfig.config+'/api/preference', request).pipe(map((response: any) => {
      return response;
    }));
  }

  setPreferences(prefs) {
    this.cache.set(
      CacheConstant.LocalStorage.Preferences,
      prefs,
      CacheDuration.OneDay
    );
  }

  getPreference(id) {
    let departmentPreferences = this.cache.get(
      CacheConstant.LocalStorage.Preferences
    );
    return departmentPreferences ? departmentPreferences[id] : null;
  }
  getsPreference() {
    let departmentPreferences = this.cache.get(
      CacheConstant.LocalStorage.Preferences
    );
    return departmentPreferences;
  }


  setpreference(id,value){
    let departmentPreferences = this.cache.get(
      CacheConstant.LocalStorage.Preferences
    );
    departmentPreferences[id].value=value;
    this.cache.set(
      CacheConstant.LocalStorage.Preferences,departmentPreferences
    );
  }
  // getAllPreferences() {
  //   // var retVal = new GenericService(this.departmentPreferences);
  //   // if (!this.departmentPreferences) {
  //   //   retVal = $http.get(preferenceConstant.get, { params: { fields: "canDisplay" } }).then(function (response) {
  //   //     this.departmentPreferences = response.data;
  //   //     return response.data;
  //   //   });
  //   // }
  //   // return retVal;
  //   return of({});
  // }
  getAllPreferences() {
    // var retVal = new GenericService(this.departmentPreferences);
    
    return super.fetch(this.apiConfig.config+'/api/preference',{params:{fields:"canDisplay"}})
    
    
  }

}
